"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _button = _interopRequireDefault(require("../../../../core/button"));
var _modal = _interopRequireDefault(require("../../../../core/modal"));
var _alert = _interopRequireDefault(require("../../../../core/alert"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const initialState = {
  lateFeesRefundRequested: false,
  isProcessing: false,
  errorMessage: null
};
var _ref = /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("p", null, "This is for when you have not set the late fees date and so charged late fees when you did not mean to!"), /*#__PURE__*/_react.default.createElement("p", null, "This will refund all late fees charged to-date (excluding those already refunded). "), /*#__PURE__*/_react.default.createElement("p", null, "You should first reset the date on which late fees become chargeable (see Dates and Limits tab), so that future entries are not charged."), /*#__PURE__*/_react.default.createElement("p", {
  className: "lead"
}, "This cannot be undone!!"));
class RefundLateFees extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", initialState);
    _defineProperty(this, "_onToggleRequest", () => {
      if (this.state.lateFeesRefundRequested) return this.setState(initialState);
      this.setState({
        lateFeesRefundRequested: true
      });
    });
    _defineProperty(this, "_onRefundLateFees", () => {
      if (this.state.isProcessing) return;
      this.setState({
        isProcessing: true
      });
      if (this.state.isProcessing) return;
      this.setState({
        isProcessing: true
      });
      return this.props.onRefundLateFees().then(result => {
        if (result && !result.success) {
          this.setState({
            errorMessage: result.message
          });
          return this.setState({
            isProcessing: false
          });
        }
        this.setState(initialState);
      });
    });
  }
  render() {
    const competition = this.props.competition;
    const today = new Date().toISOString().split('T')[0];
    const modalButtons = /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: this._onToggleRequest
    }, "Cancel!"), this.state.errorMessage ? null : /*#__PURE__*/_react.default.createElement(_button.default, {
      loading: this.state.isProcessing,
      onClick: this._onRefundLateFees
    }, "Confirm Refund"));
    return /*#__PURE__*/_react.default.createElement("div", null, competition.isCancelled || competition.startDate < today ? null : /*#__PURE__*/_react.default.createElement("div", {
      className: "pull-md-right"
    }, /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: this._onToggleRequest,
      size: "sm"
    }, "Refund All Late Fees"), !this.state.lateFeesRefundRequested ? null : /*#__PURE__*/_react.default.createElement(_modal.default, {
      title: 'Refund All Late Fees For ' + competition.competitionName,
      onClose: this._onToggleRequest,
      buttons: modalButtons
    }, this.state.errorMessage ? /*#__PURE__*/_react.default.createElement(_alert.default, {
      type: "danger"
    }, this.state.errorMessage) : _ref)));
  }

  // *******************************************************************************
  // PartialQuery definition
  // *******************************************************************************
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
_defineProperty(RefundLateFees, "partialQueries", {
  Competition: {
    id: true,
    competitionName: true,
    startDate: true,
    isCancelled: true
  }
});
var _default = exports.default = (0, _reactBicycle.connect)(RefundLateFees, undefined, (client, props) => ({
  onRefundLateFees() {
    return client.update('Competition.refundLateFees', {
      competitionID: props.competition.id
    });
  }
}));